import { PageLocatorMap } from '../types/PageLocatorMap';

export const applySearchVehiclePage = {
  footer: {
    root: 'apply-search-vehicle-page.footer.root',
  },
  form: {
    h1: 'apply-search-vehicle-page.form.h1',
    h2: 'apply-search-vehicle-page.form.h2',
    radioGroupRoot: 'apply-search-vehicle-page.form.radio-group-root',
    radioOption1: 'apply-search-vehicle-page.form.radio-option-1',
    radioOption2: 'apply-search-vehicle-page.form.radio-option-2',
    radioOption3: 'apply-search-vehicle-page.form.radio-option-3',
    root: 'apply-search-vehicle-page.form.root',
    submitButton: 'apply-search-vehicle-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
